const PROTOCOL = 'https:'
// const PROTOCOL = 'http:';
const BASE_URL = (prm) => process.env.VUE_APP_URL_ENDPOINT
export const BASE_DOWNLOAD_URL = BASE_URL().replace('api', '')
// const BASE_URL = (prm) => "http://192.168.1.41:8000/api";
// AUTHORIZATION
export const LOGIN = `${BASE_URL()}/login`
export const POST_OTP = `${BASE_URL()}/send-otp`
export const CHECK_OTP = `${BASE_URL()}/otp`
export const LOGOUT = `${BASE_URL()}/logout`
export const REFRESH_TOKEN = `${BASE_URL()}/refresh-token`
//MENU
export const LIST_MENU = `${BASE_URL()}/menu`
export const CREATE_MENU = `${BASE_URL()}/menu`
export const UPDATE_MENU = `${BASE_URL()}/menu/`
export const DELETE_MENU = `${BASE_URL()}/menu/`
//ROLE
// export const LIST_ROLE = `${BASE_URL()}/role`
export const LIST_ROLE = `${BASE_URL()}/role`
export const CREATE_ROLE = `${BASE_URL()}/role`
export const UPDATE_ROLE = `${BASE_URL()}/role/`
export const DELETE_ROLE = `${BASE_URL()}/role/`

// ROLE PERMISSION
export const LIST_ROLE_PERM = `${BASE_URL()}/role-permession`
export const CREATE_ROLE_PERM = `${BASE_URL()}/role-permession`
export const UPDATE_ROLE_PERM = `${BASE_URL()}/role-permession/`
export const DELETE_ROLE_PERM = `${BASE_URL()}/role-permession/`
//ROLE MENU
export const LIST_ROLE_MENU = `${BASE_URL()}/role-menu?`
export const CREATE_ROLE_MENU = `${BASE_URL()}/role-menu`
export const UPDATE_ROLE_MENU = `${BASE_URL()}/role-menu/`
export const DELETE_ROLE_MENU = `${BASE_URL()}/role-menu/`

//FLEET GROUP
export const LIST_FLEET_GROUP = `${BASE_URL()}/fleet-group`
export const CREATE_FLEET_GROUP = `${BASE_URL()}/fleet-group`
export const UPDATE_FLEET_GROUP = `${BASE_URL()}/fleet-group/`
export const DELETE_FLEET_GROUP = `${BASE_URL()}/fleet-group/`

//ALERT
export const LIST_ALERT = `${BASE_URL()}/alert`
export const CREATE_ALERT = `${BASE_URL()}/alert`
export const UPDATE_ALERT = `${BASE_URL()}/alert/`
export const DELETE_ALERT = `${BASE_URL()}/alert`

//ALERT SUMMARY
export const LIST_ALERT_SUMMARY = `${BASE_URL()}/mw-mapping-alert-summary?`
export const UPDATE_ALERT_SUMMARY = `${BASE_URL()}/mw-mapping-alert-summary/`

//ALERT MUTATION
export const LIST_ALERT_MUTATION = `${BASE_URL()}/mw-alert-mutation?`
export const UPDATE_ALERT_MUTATION = `${BASE_URL()}/mw-alert-mutation/`

//Alert Mapping
export const LIST_ALERT_MAPPING = `${BASE_URL()}/alert-mapping`
export const CREATE_ALERT_MAPPING = `${BASE_URL()}/alert-mapping`
export const UPDATE_ALERT_MAPPING = `${BASE_URL()}/alert-mapping/`
export const DELETE_ALERT_MAPPING = `${BASE_URL()}/alert-mapping/`

export const ALERT_HISTORY = `${BASE_URL()}/mw-mapping-alert/alert?`
export const ALERT_HISTORY_NOTIFICATION = `${BASE_URL()}/mw-mapping-alert/notification?`
export const UPDATE_ALERT_HISTORY = `${BASE_URL()}/mw-mapping-alert/`
export const UPDATE_FILE_HISTORY = `${BASE_URL()}/file-upload/`

//VEHICLE
//Provisioning
export const LIST_VEHICLE = `${BASE_URL()}/vehicle?`
export const GET_ONE_VEHICLE = `${BASE_URL()}/vehicle/`
export const CREATE_VEHICLE = `${BASE_URL()}/vehicle`
export const CHECK_FLEETIFY = `${BASE_URL()}/vehicle/check-fleetify`
export const CREATE_VEHICLE_BULK = `${BASE_URL()}/vehiclebulk`
export const UPDATE_VEHICLE = `${BASE_URL()}/vehicle/`
export const DELETE_VEHICLE = `${BASE_URL()}/vehicle/`

export const LIST_VEHICLE_MAINTENANCE = `${BASE_URL()}/vehicle-maintenance?`
export const CREATE_VEHICLE_MAINTENANCE = `${BASE_URL()}/vehicle-maintenance`
export const UPDATE_VEHICLE_MAINTENANCE = `${BASE_URL()}/vehicle-maintenance/`
export const DELETE_VEHICLE_MAINTENANCE = `${BASE_URL()}/vehicle-maintenance/`

export const UPDATE_BULK = `${BASE_URL()}/vehicle-maintenance/batch`
export const STATUS_BULK = `${BASE_URL()}/vehicle/status/`
export const UPDATE_VEHICLE_BULK = `${BASE_URL()}/vehiclebulk/`

export const LIST_VEHICLE_SHIPMENT = `${BASE_URL()}/vehicle-shipment?`
export const DETAIL_VEHICLE_SHIPMENT = `${BASE_URL()}/vehicle-shipment/`
export const CREATE_VEHICLE_SHIPMENT = `${BASE_URL()}/vehicle-shipment`
export const UPDATE_VEHICLE_SHIPMENT = `${BASE_URL()}/vehicle-shipment/`
export const DELETE_VEHICLE_SHIPMENT = `${BASE_URL()}/vehicle-shipment/`

//Driver
export const LIST_DRIVER = `${BASE_URL()}/driver?`
export const CREATE_DRIVER = `${BASE_URL()}/driver`
export const UPDATE_DRIVER = `${BASE_URL()}/driver/`
export const DELETE_DRIVER = `${BASE_URL()}/driver/`

//BRAND
export const LIST_BRAND = `${BASE_URL()}/brand`
export const CREATE_BRAND = `${BASE_URL()}/brand`
export const UPDATE_BRAND = `${BASE_URL()}/brand/`
export const DELETE_BRAND = `${BASE_URL()}/brand/`
//MODEL
export const LIST_MODEL = `${BASE_URL()}/model`
export const CREATE_MODEL = `${BASE_URL()}/model`
export const UPDATE_MODEL = `${BASE_URL()}/model/`
export const DELETE_MODEL = `${BASE_URL()}/model/`
//LEVEL
export const LIST_LEVEL = `${BASE_URL()}/level`

//DEVICE
export const LIST_DEVICE_TYPE = `${BASE_URL()}/device-types`
export const LIST_DEVICE_GROUP = `${BASE_URL()}/device-groups`
export const LIST_DEVICE_MODEL = `${BASE_URL()}/device-models`
export const LIST_END_POINTS = `${BASE_URL()}/end-points`

//GEOFENCE

export const LIST_GEOFENCE = `${BASE_URL()}/geofence`
export const GET_GEOFENCE = `${BASE_URL()}/geofence/`
export const CREATE_GEOFENCE = `${BASE_URL()}/geofence`
export const UPDATE_GEOFENCE = `${BASE_URL()}/geofence/`
export const DELETE_GEOFENCE = `${BASE_URL()}/geofence/`

//GEOFENCE CATEGORY
export const LIST_GEOFENCE_CATEGORY = `${BASE_URL()}/geofence-category?`
export const DETAIL_GEOFENCE_CATEGORY = `${BASE_URL()}/geofence-category/`
export const CREATE_GEOFENCE_CATEGORY = `${BASE_URL()}/geofence-category`
export const UPDATE_GEOFENCE_CATEGORY = `${BASE_URL()}/geofence-category/`
export const DELETE_GEOFENCE_CATEGORY = `${BASE_URL()}/geofence-category/`

//GEOFENCE DETAIL
export const CREATE_GEOFENCE_DETAIL = `${BASE_URL()}/geofence-detail`
export const UPDATE_GEOFENCE_DETAIL = `${BASE_URL()}/geofence-detail/`
export const GET_GEOFENCE_DETAIL = `${BASE_URL()}/geofence/`

//PAIRING GEOFENCE VEHICLE
export const GET_VEHICLE_FLEETGROUP = `${BASE_URL()}/vehicle/fleet-group/` // +id_fleet_group
export const GET_VEHICLE_GEOFENCE = `${BASE_URL()}/geofence-vehicle/geofence/` // +id_geofence
export const UPDATE_VEHICLE_GEOFENCE = `${BASE_URL()}/geofence-vehiclebulk/geofence/` // +id_geofence

//USERS
export const LIST_USER = `${BASE_URL()}/user?`
export const UPDATE_PASS_BULK = `${BASE_URL()}/user/monthly-password`

export const ACTIVATE_USER = `${BASE_URL()}/user/activation/`
export const USER_RESEND_ACTIVATION = `${BASE_URL()}/user-resend/`
export const CREATE_PASSWORD = `${BASE_URL()}/create-password/`
export const FORGOT_PASSWORD = `${BASE_URL()}/forgot-password?`
export const CREATE_USER = `${BASE_URL()}/user`
export const UPDATE_USER = `${BASE_URL()}/user/`
export const DELETE_USER = `${BASE_URL()}/user/`

//DASHBOARD

export const DASHBOARD = `${BASE_URL()}/dashboard`
export const FEET_GROUP_CHILD = `${BASE_URL()}/fleet-group/child/`
export const DASHBOARD_TOTAL_VEHICLE = `${BASE_URL()}/total-vehicle/fleet-group/`
// export const DASHBOARD_GEOFENCE_VIOLATION = `${BASE_URL()}/geofence-violation/fleet-group/`
export const DASHBOARD_GEOFENCE_VIOLATION = `${BASE_URL()}/inoperation-vehicle/fleet-group/`
export const DASHBOARD_MOVING_VEHICLE = `${BASE_URL()}/moving-vehicle/fleet-group/`
export const DASHBOARD_IDLE_VEHICLE = `${BASE_URL()}/idle-vehicle/fleet-group/`
export const DASHBOARD_STOP_VEHICLE = `${BASE_URL()}/stop-vehicle/fleet-group/`
export const DASHBOARD_SILENT_VEHICLE = `${BASE_URL()}/silent-vehicle/fleet-group/`
export const DASHBOARD_REPAIR_VEHICLE = `${BASE_URL()}/repair`

export const AUTOCOMPLETE_DASHBOARD = `${BASE_URL()}/total-vehicle/fleet-group/`

export const DOWNLOAD_TOTAL = `${BASE_URL()}/mw-mapping/download/`
export const DASHBOARD_DOWNLOAD = `${BASE_URL()}/mw-mapping/dashboard-download`

// DASHBOARD V2
// Urgent
export const DASHBOARD_GET_MB_CN = `${BASE_URL()}/urgent/mb-cn-vehicle/fleet-group/`
export const DASHBOARD_GET_URGENT_ACCIDENT = `${BASE_URL()}/urgent/accident-vehicle/fleet-group/`
export const DASHBOARD_GET_OVERSTAY_ON = `${BASE_URL()}/urgent/overstay-engine-on-vehicle/fleet-group/`
export const DASHBOARD_GET_OVERSTAY_OFF = `${BASE_URL()}/urgent/overstay-engine-off-vehicle/fleet-group/`
export const DASHBOARD_GET_GEOFENCE_IN = `${BASE_URL()}/urgent/geofence-in-vehicle/fleet-group/`
export const DASHBOARD_GET_GEOFENCE_OUT = `${BASE_URL()}/urgent/geofence-out-vehicle/fleet-group/`
export const DASHBOARD_GET_OVERTEMP = `${BASE_URL()}/urgent/over-temperatur-vehicle/fleet-group/`
export const DASHBOARD_GET_UNDERTEMP = `${BASE_URL()}/urgent/under-temperatur-vehicle/fleet-group/`
export const DASHBOARD_GET_DOOR_OPEN = `${BASE_URL()}/urgent/door-open-vehicle/fleet-group/`

export const DASHBOARD_GET_OVERSTAY_PRECENTAGES = `${BASE_URL()}/urgent/overstay-percentages-vehicle/fleet-group/`
export const DASHBOARD_GET_GEOFENCE_PRECENTAGES = `${BASE_URL()}/urgent/geofence-percentages-vehicle/fleet-group/`
export const DASHBOARD_GET_TEMPERATURE_PRECENTAGES = `${BASE_URL()}/urgent/temperature-percentages-vehicle/fleet-group/`

// Summary
export const DASHBOARD_GET_TOTAL_OVERSPEED = `${BASE_URL()}/summary/total-overspeed-vehicle/fleet-group/`
export const DASHBOARD_GET_TOTAL_HARSH_ACC = `${BASE_URL()}/summary/total-harsh-acceleration-vehicle/fleet-group/`
export const DASHBOARD_GET_TOTAL_HARSH_BRK = `${BASE_URL()}/summary/total-harsh-brake-vehicle/fleet-group/`
export const DASHBOARD_GET_TOTAL_ACCIDENT = `${BASE_URL()}/summary/total-accident-vehicle/fleet-group/`
export const DASHBOARD_GET_TOTAL_VERIFIED_ALERT = `${BASE_URL()}/summary/total-verified-alert-vehicle/fleet-group/`
export const DASHBOARD_GET_TOTAL_UNVERIFIED_ALERT = `${BASE_URL()}/summary/total-unverified-alert-vehicle/fleet-group/`

export const DASHBOARD_GET_TOP_OVERSPEED = `${BASE_URL()}/summary/top-10-overspeed/fleet-group/`
export const DASHBOARD_GET_TOP_HARSH_ACC = `${BASE_URL()}/summary/top-10-harsh-acceleration/fleet-group/`
export const DASHBOARD_GET_TOP_HARSH_BRK = `${BASE_URL()}/summary/top-10-harsh-brake/fleet-group/`
export const DASHBOARD_GET_TOP_ACCIDENT = `${BASE_URL()}/summary/top-10-accident/fleet-group/`
export const DASHBOARD_GET_TOP_VERIFIED_ALERT = `${BASE_URL()}/summary/top-10-verified/fleet-group/`
export const DASHBOARD_GET_TOP_UNVERIFIED_ALERT = `${BASE_URL()}/summary/top-10-unverified/fleet-group/`

// Analytics
export const DASHBOARD_GET_OVERSPEED = `${BASE_URL()}/analytics/total-overspeed-vehicle/fleet-group/`
export const DASHBOARD_GET_HARSH_ACC = `${BASE_URL()}/analytics/total-harsh-acceleration-vehicle/fleet-group/`
export const DASHBOARD_GET_HARSH_BRK = `${BASE_URL()}/analytics/total-harsh-brake-vehicle/fleet-group/`
export const DASHBOARD_GET_ACCIDENT = `${BASE_URL()}/analytics/total-accident-vehicle/fleet-group/`
export const DASHBOARD_GET_VERIFIED_ALERT = `${BASE_URL()}/analytics/total-verified-alert/fleet-group/`
export const DASHBOARD_GET_UNVERIFIED_ALERT = `${BASE_URL()}/analytics/total-unverified-alert/fleet-group/`
export const DASHBOARD_GET_NOT_YET_VERIFIED_ALERT = `${BASE_URL()}/analytics/total-notyetverified-alert/fleet-group/`
export const DASHBOARD_GET_MB_CN_ANALYTICS = `${BASE_URL()}/analytics/main-battery-disconnected/fleet-group/`
export const DASHBOARD_GET_OVERSTAY_OFF_ANALYTICS = `${BASE_URL()}/analytics/overstay-engine-off-vehicle/fleet-group/`
export const DASHBOARD_GET_OVERSTAY_ON_ANALYTICS = `${BASE_URL()}/analytics/overstay-engine-on-vehicle/fleet-group/`
export const DASHBOARD_GET_OVERTEMP_ANALYTICS = `${BASE_URL()}/analytics/over-temperature-vehicle/fleet-group/`
export const DASHBOARD_GET_DOOR_OPEN_ANALYTICS = `${BASE_URL()}/analytics/rear-door-open-vehicle/fleet-group/`
export const DASHBOARD_GET_ACTIVE_VEHICLE = `${BASE_URL()}/analytics/active-vehicle/fleet-group/`
export const DASHBOARD_GET_STATUS_VEHICLE = `${BASE_URL()}/analytics/status-vehicle/fleet-group/`
export const DASHBOARD_GET_RITATION_VEHICLE = `${BASE_URL()}/ritase-analytic/`
export const DASHBOARD_GET_IN_OPERATION_VEHICLE = `${BASE_URL()}/analytics/inoperation-vehicle/fleet-group/`
export const DASHBOARD_GET_UTILIZATION_RATE_VEHICLE = `${BASE_URL()}/analytics/utilization-vehicle/fleet-group/`
export const DASHBOARD_GET_STATUS_ALERT = `${BASE_URL()}/analytics/status-alert/fleet-group/`

export const DASHBOARD_GET_PRECENTAGES_OVERSTAY = `${BASE_URL()}/analytics/percentages-vehicle/overstay-percentages-vehicle/fleet-group/`
export const DASHBOARD_GET_PRECENTAGES_GEOFENCE = `${BASE_URL()}/analytics/percentages-vehicle/geofence-percentages-vehicle/fleet-group/`
export const DASHBOARD_GET_PRECENTAGES_TEMPERATURE = `${BASE_URL()}/analytics/percentages-vehicle/temperature-percentages-vehicle/fleet-group/`

// Analytics DMS
export const DASHBOARD_GET_DMS_GPS_OVERSPEED = `${BASE_URL()}/analytics/dms/alert/gps-overspeed/`
export const DASHBOARD_GET_DMS_BASED_ON_TIME = `${BASE_URL()}/analytics/dms/alert/based-on-time/`
export const DASHBOARD_GET_DMS_BASED_ON_CATEGORY = `${BASE_URL()}/analytics/dms/alert/based-on-category/`

//MONITORING

export const LIST_VEHICLE_CLUSTER = `${BASE_URL()}/vehicle-monitoring/cluster/fleet-group/`
export const GET_ONE_MW_MAPPING = `${BASE_URL()}/vehicle-monitoring/cluster/mw-mapping/`
export const FILTER_PARAM = `${BASE_URL()}/vehicle-monitoring/child/fleet-group/`
export const FILTER_LICENSE = `${BASE_URL()}/vehicle-monitoring/filter/license-plate`
export const LICENSE_BY_FLEET = `${BASE_URL()}/fleet-group/list/all-license-plate`
export const CLUSTER_FILTER = `${BASE_URL()}/vehicle-monitoring/filter?`
export const SUBSCRIBE_VEHICLE = `${BASE_URL()}/mw-mapping/subscribe/`
export const UNSUBSCRIBE_VEHICLE = `${BASE_URL()}/mw-mapping/unsubscribe/`
export const PLAYBACK = `${BASE_URL()}/mw-mapping-history?`
export const GET_VEHICLE_TRIP = `${BASE_URL()}/geofence-vehicle-history/`
export const GET_VEHICLE_RITASE = `${BASE_URL()}/ritase/`
export const POST_VEHICLE_COMMAND = `${BASE_URL()}/command/command`

export const FILTER_LIC_VIN_IMEI = `${BASE_URL()}/vehicle-monitoring/child-vehicle/fleet-group/`
export const LIST_VEHICLE_CATEGORY = `${BASE_URL()}/vehicle-category`
export const LIST_VEHICLE_ACCU = `${BASE_URL()}/accu`

export const GET_LIVE_MONITORING = `${BASE_URL()}/live-track/`
export const POST_LIVE_MONITORING = `${BASE_URL()}/live-track/`

export const POST_CALIBRATE = `${BASE_URL()}/command`

// CAMERA
export const cameraUrl = 'https://camera-stream.treffix.id'
// const tmpUrl = 'http://35.198.202.131:6060'
const tmpUrl = 'https://api-camera.treffix.id'
export const GET_MONITORING_ALERT_CAMERA = `${tmpUrl}/GetAlarmHistoryData/100`
export const GET_RECORD_BY_ALARM_ID = `${tmpUrl}/GetRecordFromAlarmId/100`
// export const TEST_GET_RECORD_BY_ALARM_ID = `${tmpUrl}/GetDeviceFileList/`
// export const TEST_GET_RECORD_BY_ALARM_ID = `${tmpUrl}/GetRecordFileList/100`
export const TEST_GET_RECORD_BY_ALARM_ID = `${tmpUrl}/GetRecordFromAlarmId/100`

// METTAX
export const mettaxiotUrl = `https://mettahub.mettaxiot.com/gps/v2/openapi`
export const GET_METTAX_TOKEN = `${mettaxiotUrl}/system/createToken`
export const METTAX_LIVE_CAM = `${mettaxiotUrl}/video/live`
export const METTAX_ALERT_LIST = `${mettaxiotUrl}/alarm/file/page`
export const METTAX_ALERT_BY_ALARMID = `${mettaxiotUrl}/alarm/file/id`
export const METTAX_PLAYBACK_LIST = `${mettaxiotUrl}/video/history/list`
export const METTAX_PLAYBACK = `${mettaxiotUrl}/video/history/replay`
export const METTAX_TALK_PLUS = `${mettaxiotUrl}/audio/talk/plus`

// REPORT
// export const URL_LOGIN_MICROSOFT = "https://login.microsoftonline.com/common/oauth2/token";
export const URL_LOGIN_MICROSOFT = `https://bitrack.id/api/login/power-bi`
export const URL_GENERATE_TOKEN_STATIC =
  'https://api.powerbi.com/v1.0/myorg/groups/9542965e-d501-472b-b76e-2262e3fc7b14/reports/a3aeefe2-176b-400e-9abb-ffff8aef968f/GenerateToken'
export const URL_GENERATE_TOKEN_STATIC_SAMPLE =
  'https://api.powerbi.com/v1.0/myorg/groups/91a5ae0f-6fb1-45ad-bb09-64bcb002ba1c/reports/2d2a315c-36a3-452b-a384-445dd48ae545/GenerateToken'
export const URL_GENERATE_TOKEN_DASHBOARD_ANALYTICS =
  'https://api.powerbi.com/v1.0/myorg/groups/91a5ae0f-6fb1-45ad-bb09-64bcb002ba1c/reports/85f4bf9f-08ff-4292-83f7-f869510f9ee4/GenerateToken'
export const URL_GENERATE_TOKEN_DYNAMIC =
  'https://api.powerbi.com/v1.0/myorg/groups/'

//BACKUP LINK
export const URL_LOGIN_MW = 'https://obdmwsera.azurewebsites.net/oauth/token'
export const MW_GET_LAST_POSITION =
  'https://obdmwsera.azurewebsites.net/api/v1/backend/query-device-message'

export const GET_PARAM_POWER_BY = `https://bitrack.id/api/power-bi`

//POI

export const CATEGORY_POI = `${BASE_URL()}/category_poi`
export const POI_FLEETGROUP = `${BASE_URL()}/poi-vehiclebulk/poi/`
export const POI = `${BASE_URL()}/poi`
export const POI_PARAM = `${BASE_URL()}/show_poi`

export const BASE_FILE = `${BASE_URL()}`

//IMOBILIZE

export const IMO = `${BASE_URL()}/imo`

// GET HISTORY
export const GET_HISOTY = `${BASE_URL()}/mw-mapping-history/`

//MASTER REPORT
export const GET_REPORT_PARAM = `${BASE_URL()}/report`
export const GET_REPORT_MAPPING = `${BASE_URL()}/report-mapping`
export const GET_REPORT_FLEET = `${BASE_URL()}/report-mapping/fleet-group`

const GOLANG_URL = (prm) => process.env.VUE_APP_GOLANG_ENDPOINT

// LIVE TRACKING API 
export const LIVE_TRACKING = `${BASE_URL()}/live-track-share/last-position`
export const LIVE_TRACKING_AUTH = `${BASE_URL()}/live-track/last-position`

// EXPORT
export const GET_EXPORT_HISTORY = `${BASE_URL()}/download`
export const EXPORT_REPORT = `${GOLANG_URL()}/export-sender`
export const EXPORT_REPORT_V2 = `${GOLANG_URL()}/v2/exports`

// PLAYGROUND
export const PLAYGROUND = `${GOLANG_URL()}/dev/playground-opi`

const OPENSTREET_URL = (prm) => {
  return 'https://map.b-log.dev'
}
//ADDRESS
// export const GET_ADDRESS = `${GOLANG_URL()}/open-street?`
export const GET_ADDRESS = `${OPENSTREET_URL()}/reverse?`
